import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header__content">
          <div className="header__logo">
            <div className="logo__icon">
              <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M128 470 L470 470 L470 128 L128 128Z  M214 214 L384 214 L384 384 L214 384Z  M128 896 L470 896 L470 554 L128 554Z  M214 640 L384 640 L384 810 L214 810Z  M554 128 L554 470 L896 470 L896 128Z  M810 384 L640 384 L640 214 L810 214Z  M810 810 L896 810 L896 896 L810 896Z  M554 554 L640 554 L640 640 L554 640Z  M640 640 L726 640 L726 726 L640 726Z  M554 726 L640 726 L640 810 L554 810Z  M640 810 L726 810 L726 896 L640 896Z  M726 726 L810 726 L810 810 L726 810Z  M726 554 L810 554 L810 640 L726 640Z  M810 640 L896 640 L896 726 L810 726Z"/>
              </svg>
            </div>
            <div className="logo__text">
              <span className="logo__blue">чеки </span>
              <span className="logo__orange">Челябинск</span>
            </div>
          </div>

          <nav className={`header__nav ${isMenuOpen ? 'header__nav--open' : ''}`}>
            <ul className="nav__list">
              <li className="nav__item">
                <a href="#hero" className="nav__link" onClick={closeMenu}>Главная</a>
              </li>
              {/* <li className="nav__item">
                <a href="#about" className="nav__link" onClick={closeMenu}>О нас</a>
              </li> */}
              <li className="nav__item">
                <a href="#gallery" className="nav__link" onClick={closeMenu}>Примеры</a>
              </li>
              <li className="nav__item">
                <a href="#contact" className="nav__link" onClick={closeMenu}>Контакты</a>
              </li>
            </ul>
          </nav>

          <div className="header__contact">
            <a href="tel:+79874817932" className="contact__phone">+7 (987) 481-79-32</a>
          </div>

          <button 
            className={`header__menu-toggle ${isMenuOpen ? 'header__menu-toggle--active' : ''}`}
            onClick={toggleMenu}
            aria-label="Открыть меню"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;